import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import RaceList from "../common/RaceList";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceUnawardedPrices extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            selectedRaces: [],
        });
    }

    fields = [];
    render() {
        return <div className="race-unawarded-prices">
            <div className="race-list">
                <RaceList selectedRaces={this.state.selectedRaces} updateSelection={this.updateRaceSelection} filterRaces={race => this.props.auth.currentRole !== UserRoles.SECTION_ADMIN.id || race.Sektion === this.props.auth.currentEntity}/>
            </div>
            <div className="report-options">
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    updateRaceSelection = (races, add = true) => {
        this.setState({
            selectedRaces: add ? this.state.selectedRaces.concat(races.filter(race => this.state.selectedRaces.indexOf(race) < 0)) : this.state.selectedRaces.filter(race => races.indexOf(race) < 0)
        })
    };

    getReportOptions = () => {
        const errors = [];
        if (this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
        return {
            errors: errors,
            options: {
                races: this.state.selectedRaces
            },
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceUnawardedPrices);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/RaceUnawardedPrices.js